
import { motion } from "framer-motion";

const FortunePageHeader = () => {
  return (
    <div className="text-center mb-10">
      <motion.h1 
        className="text-4xl font-light mb-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        Create Your Own Fortune
      </motion.h1>
      <motion.p
        className="text-muted-foreground text-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        Craft a personalized fortune for yourself or to share with others
      </motion.p>
    </div>
  );
};

export default FortunePageHeader;
